import React from 'react';

const ClienteTitle = (props) => {
    const { empresas, novedadesEmpresas, cliente } = props;
    const descripcion = (cliente.esPersonaFisica ? cliente.NOMBRE + " " + cliente.APELLIDO : cliente.RAZON_SOCIAL)


    let textoSolicitud = "Solicitud para ";
    let cuit = "";

    if(cliente.Cuit){ 
        cliente.Cuit = cliente.Cuit.toString();
        cuit = cliente.Cuit.includes("-") ? cliente.Cuit : cuit + cliente.Cuit.substring(0,2) + "-" +cliente.Cuit.substring(2,((cliente.Cuit.length)-1)) + "-" +cliente.Cuit[cliente.Cuit.length-1] 
    }
    
    return (
        <div className="bottom-separator-xs">
            <div className="row">
                <div className="col-md-12">
                    <h1>
                        {(props.esModificacion == true ? textoSolicitud : "Nueva Solicitud para ") + descripcion}
                    </h1>
                </div>
            </div>
            {<div className="row">
                <div className="col-md-12">
                    <ul className="no-bullets no-padding no-margin">
                        <li className="inlineListItem lg-margin clienteSubtitle">
                            <span className="icon-ti-user-icon-persona-cyan"></span>&nbsp;  CUIT {cuit}
                        </li>
                        <li className="inlineListItem lg-margin clienteSubtitle">
                            <span className="fa fa-money"></span>     Límite total: $ {cliente.Id>0 ? (cliente.LimitePorCuit ? cliente.LimitePorCuit : cliente.limiteCompraEmpresaOperativa) : "0" }                        
                        </li>
                        <li className="inlineListItem lg-margin clienteSubtitle">
                            <span className="icon-available-limit22"></span>     Límite total asignado: $ {cliente.limiteCompraEmpresaOperativa ? cliente.limiteCompraEmpresaOperativa : "0" }
                        </li>
                        <li className="inlineListItem lg-margin clienteSubtitle">
                            <span className="icon-limite-total-sin-asignar"></span>     Límite total sin asignar: $ {cliente.LimitePorCuit ? (parseInt(cliente.LimitePorCuit) - parseInt(cliente.limiteCompraEmpresaOperativa)) : "0"}
                        </li>
                    </ul>
                </div>
            </div>}
        </div>
    );
}

export default ClienteTitle;